import React from 'react';
import styled from 'styled-components';
import { useI18n } from '@whizz/react-i18n';

interface Props {
  children?: JSX.Element | null;
}

const FormGenericError = ({ children }: Props): JSX.Element => {
  const { translate } = useI18n();

  return (
    <FieldErrorStyled className={'space-y-2'}>
      <p>{children ?? translate('global.REVIEW_FORM')}</p>
    </FieldErrorStyled>
  );
};

const FieldErrorStyled = styled('div')`
  color: ${(props) => props.theme.colors.error};
`;

export default FormGenericError;
